import ActivityItem from './model';

export default ActivityItem;



// WEBPACK FOOTER //
// ./data/CoveredInClass/Activity/ActivityItem/index.js